import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
            <motion.span
                className="block will-change-transform"
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, ease: EASE, delay }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ children, light = false }) {
    return (
        <p
            className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] ${
                light ? "text-brand" : "text-brand"
            }`}
        >
            <span className="h-px w-8 bg-cherry" />
            {children}
        </p>
    );
}
